export function cleanPhone(phone) {
  return phone.replace(/\D/g, '');
}
